import { Context } from "../../../context.js";
import { PseudoClassSelector } from "./pseudo-class.js";
/**
 * {@link https://drafts.csswg.org/selectors/#focus-pseudo}
 */
export class Focus extends PseudoClassSelector {
    static of() {
        return new Focus();
    }
    constructor() {
        super("focus");
    }
    *[Symbol.iterator]() {
        yield this;
    }
    matches(element, context = Context.empty()) {
        return context.isFocused(element);
    }
    toJSON() {
        return super.toJSON();
    }
}
(function (Focus) {
    Focus.parse = PseudoClassSelector.parseNonFunctional("focus", Focus.of);
})(Focus || (Focus = {}));
//# sourceMappingURL=focus.js.map